import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ApplicationState } from '../../../../shared/state/application-state.service';
import { PowerBiApi } from '../../models/power-bi-models';
import { PowerBiState } from '../../state/power-bi-state.service';


@Component({
    selector: 'app-workspace-selector',
    imports: [CommonModule, FormsModule],
    templateUrl: './workspace-selector.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WorkspaceSelector {

  applicationStateService = inject(ApplicationState);
  powerbiState = inject(PowerBiState);

  activeWorkspace = this.powerbiState.selectedWorkspace;
  currentWorkspaces = this.powerbiState.workspaces;
  
  searchQuery = signal<string>('');
  items = computed(() => {
    const sq = this.searchQuery();
    const ws = this.currentWorkspaces();
    if (sq === '') return ws;
    const result = ws.filter((workspace : PowerBiApi.Workspace) => workspace.name.toLowerCase().includes(sq.toLowerCase()));
    return result;
  });

  showSearchField = computed(() => this.currentWorkspaces().length > 5);
  showChangeWorkspaceTip = computed(() => this.currentWorkspaces().length > 1);

  onSearchUpdated(sq: string) {
    this.searchQuery.set(sq);
  }

  setActiveWorkspace(workspaceId: string | null) {
    this.powerbiState.selectWorkspace(workspaceId);
  }
}
